"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var formatSize_1 = require("utils/helpers/formatSize");
var Icon_1 = require("components/Icon");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('element', 'setElement', null), recompose_1.pure);
var fileTypeRegExp = /\.([\w]+)$/;
var getFileType = function (file) {
    var result = fileTypeRegExp.exec(file);
    return result && result.length > 1 ? result[1] : 'file';
};
var getErrorMessage = function (_a) {
    var error = _a.error;
    if (error) {
        if (error.type === 'ENTITY_TOO_LARGE') {
            return 'File is too large';
        }
        if (error.type === 'NOT_ACCEPTABLE') {
            return 'File is not supported';
        }
    }
    return '';
};
var getIcon = function (props, file) {
    var status = (props.wizard.uploadedItems[file.uuid] || {
        status: 'STANDBY'
    }).status;
    if (status === 'UPLOADING') {
        return React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin', prefix: 'far' });
    }
    else if (status === 'FAILURE') {
        return (React.createElement("abbr", { title: getErrorMessage(props.wizard.uploadedItems[file.uuid]) },
            React.createElement(Icon_1.Icon, { className: 'fa-exclamation-triangle' })));
    }
    else if (status === 'UPLOADED') {
        return React.createElement(Icon_1.Icon, { className: 'fa-check' });
    }
    return React.createElement(Icon_1.Icon, { className: 'fa-times', onClick: props.removeFile(file) });
};
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'contract-files' },
    React.createElement("div", null,
        React.createElement("label", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/agreementDocuments')),
        React.createElement("input", { type: 'file', ref: props.setElement, multiple: true, onChange: (0, sok_ui_1.handleDrop)({
                multipleFiles: true,
                value: props.step1.files,
                onChange: props.setFiles
            }) }),
        React.createElement(sok_ui_1.Button, { className: 'add-contract-file', color: 'base-blue', text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/addFiles'), disabled: props.wizard.uploadingContractFiles === 'UPLOADING', onClick: function () { return props.element && props.element.click(); } })),
    React.createElement("div", { className: 'clear-attachment' }, props.step1.files.length > 0 && (React.createElement("span", { onClick: function () { return props.setFiles([]); } }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/clearAllNewFiles')))),
    React.createElement("div", { className: 'file-list' },
        props.step1.contractFiles.map(function (file, k) { return (React.createElement("div", { key: k, className: 'file-list-row' },
            React.createElement("div", null,
                React.createElement(Icon_1.Icon, { className: "file-type-".concat(getFileType(file.name)) })),
            React.createElement("div", null,
                React.createElement("a", { target: '_blank', href: "".concat(__APIBASEURL__, "api/customer/").concat(props.wizard.customerUuid, "/contract-file/").concat(file.id) },
                    React.createElement("abbr", { title: file.name }, file.name)),
                ' ',
                "\u2013 ",
                (0, formatSize_1.formatSize)(file.size)))); }),
        props.step1.contractFiles.length > 0 && props.step1.files.length > 0 && (React.createElement("span", { className: 'new-files-title' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/newFiles'))),
        props.step1.files.map(function (file, k) { return (React.createElement("div", { key: k, className: 'file-list-row' },
            React.createElement("div", null,
                React.createElement(Icon_1.Icon, { className: "file-type-".concat(getFileType(file.name)) })),
            React.createElement("div", null,
                React.createElement("abbr", { title: file.name }, file.name),
                " \u2013",
                ' ',
                (0, formatSize_1.formatSize)(file.size),
                file.size > 5368709120 && (React.createElement("abbr", { title: 'Max file size is 5GB', className: 'error' },
                    React.createElement(Icon_1.Icon, { className: 'fa-exclamation' }))),
                props.wizard.uploadedItems[file.uuid] && (React.createElement("span", { className: 'uploaded' },
                    props.wizard.uploadedItems[file.uuid].uploaded,
                    " %"))),
            getIcon(props, file))); }),
        props.step1.files.length === 0 &&
            props.step1.contractFiles.length === 0 && (React.createElement("div", { className: 'no-files' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/thereIsNoFiles')))))); });
